import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { MarkdownLink } from 'site-modules/canvas/components/chat-messages/ai-message/markdown/markdown-link/markdown-link';

import './user-message.scss';

const MARKDOWN_PLUGINS = [remarkGfm]; // never add rehype-raw here
const ALLOWED_SCHEMES = /^(https?:|\/|#)/i;
const markdownComponents = {
  blockquote: ({ node, children, ...restProps }) => {
    return (
      <blockquote {...restProps} className={classnames(restProps.className, 'pos-r ps-1 mb-1 fst-italic')}>
        {children}
      </blockquote>
    );
  },
  img({ alt }) {
    return <span>{alt}</span>;
  },
  a({ href = '#', children, ...restProps }) {
    const safeHref = ALLOWED_SCHEMES.test(href) ? href : '#';

    return (
      <MarkdownLink {...restProps} href={safeHref}>
        {children}
      </MarkdownLink>
    );
  },
};

export function UserMessage({ message: { text }, className, isChatMessage = false, onRender }) {
  const messageRef = useRef();

  useEffect(() => {
    onRender(messageRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={messageRef}
      className={classnames('user-message bg-cool-gray-20 text-white px-0_75 py-0_75', className)}
      data-chat-message={isChatMessage ? 'true' : undefined}
    >
      <span className="visually-hidden">You said:</span>
      <div className="ai-message-markdown">
        <ReactMarkdown remarkPlugins={MARKDOWN_PLUGINS} components={markdownComponents}>
          {text}
        </ReactMarkdown>
      </div>
    </div>
  );
}

UserMessage.propTypes = {
  message: PropTypes.shape({
    text: PropTypes.string,
  }).isRequired,
  onRender: PropTypes.func.isRequired,
  className: PropTypes.string,
  isChatMessage: PropTypes.bool,
};
